import { Loader } from "@circle-react-uikit/Loader";
import { Modal } from "@circleco/compass/components/Modal";
import type { ReactNode } from "react";

export type MomentumModalV4Props = Readonly<{
  children?: ReactNode;
  description: string;
  isLoading?: boolean;
  isOpen?: boolean;
  multiCTASectionLayout?: boolean;
  onClose?: () => void | Promise<void> | Promise<unknown>;
  title: string;
}>;

export const MomentumModalV4 = ({
  title,
  description,
  onClose,
  children,
  isLoading,
  isOpen,
  multiCTASectionLayout = false,
}: MomentumModalV4Props) => {
  const handleOpenChange = (open: boolean) => {
    if (!open) {
      void onClose?.();
    }
  };

  return (
    <Modal.Root
      open={isOpen}
      onOpenChange={handleOpenChange}
      size={multiCTASectionLayout ? "lg" : "md"}
    >
      <Modal.Content>
        {isLoading && (
          <div className="absolute inset-0 z-10 flex items-center justify-center">
            <Loader aria-live="polite" aria-busy="true" />
          </div>
        )}
        <Modal.Header
          title={title}
          description={description}
          showCloseButton={!!onClose}
        />
        <Modal.Body>{children}</Modal.Body>
      </Modal.Content>
    </Modal.Root>
  );
};
